import React from "react";
import { useTransactionFlow } from "@/context/TransactionContext";
import { TRANSACTION_STATES } from "@/app/components/payment/reducers";
import DigioStep from "@/app/components/payment/components/digio-step";
import PaymentStep from "@/app/components/payment/components/payment-step";
import SuccessModal from "./components/success";
import FailedModal from "./components/failure";
import ErrorModal from "./components/error";
import { ThirdPartyData } from "@/app/interface/docvault";
import Top3StocksModal from "./components/success-top-stocks";
import { UEListData } from "@/app/interface/homepage";

interface TransactionFlowProps {
    isAdvisory?: boolean;
    thirdPartyData?: ThirdPartyData | undefined;
    onComplete: () => void;
    restartFlow: () => void;
    isRepeatTxn?: boolean;
    onClose: (value: boolean) => void;
    units: number;
    isin: string;
    userId?: string | undefined;
    userNotInvested?: boolean;
    popularStocks?: UEListData[];
}

const TransactionFlow: React.FC<TransactionFlowProps> = ({
    isAdvisory,
    restartFlow,
    onComplete,
    onClose,
    thirdPartyData,
    isin,
    userId,
    isRepeatTxn,
    userNotInvested,
    popularStocks,
}) => {
    const { state } = useTransactionFlow();

    const renderStep = () => {
        switch (state.currentState) {
            case TRANSACTION_STATES.DIGIO_FLOW:
                return (
                    <DigioStep
                        onComplete={onComplete}
                        onClose={onClose}
                        isAdvisoryFlow={isAdvisory}
                    />
                );
            case TRANSACTION_STATES.PAYMENT_CHOICE:
                return (
                    <PaymentStep
                        onComplete={onComplete}
                        thirdPartyData={thirdPartyData}
                        userId={userId}
                        isAdvisoryFlow={isAdvisory}
                    />
                );
            case TRANSACTION_STATES.COMPLETED:
                return !isRepeatTxn ? (
                    <Top3StocksModal
                        thirdPartyData={thirdPartyData}
                        userId={userId}
                        userNotInvested={userNotInvested}
                        isin={isin}
                        top3Stocks={popularStocks
                            ?.filter((s: UEListData) => s.category === "live")
                            .slice(0, 3)}
                    />
                ) : (
                    <SuccessModal
                        isin={isin}
                        userNotInvested={userNotInvested}
                        onComplete={onComplete}
                        thirdPartyData={thirdPartyData}
                        userId={userId}
                    />
                );
            case TRANSACTION_STATES.FAILED:
                return <FailedModal onComplete={onComplete} isAdvisoryFlow={isAdvisory} />;
            case TRANSACTION_STATES.ERROR:
                return (
                    <ErrorModal
                        onComplete={onComplete}
                        restartFlow={restartFlow}
                        isAdvisoryFlow={isAdvisory}
                    />
                );
            default:
                return <div>Loading...</div>;
        }
    };

    return <div className="mx-auto max-w-2xl">{renderStep()}</div>;
};

export default TransactionFlow;
